import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import api from "../../utils/api";
import { StringNumber, Tarefa } from "../../types";



export const SelectTarefa = ({ idevento, action, valor: _val }: { idevento: number, action: any, valor?: StringNumber | null }) => {

  const [tarefas, setTarefas] = useState<Tarefa[]>();

  const getMinisterio = async () => {
    try {
      const req = await api.get('evento/tarefa/' + idevento);
      const res = req?.data;

      setTarefas(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getMinisterio()
  }, [idevento])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Tarefas</FormLabel>
        {
          idevento && (
            <Select
              value={_val}
              onChange={action}
            >
              {
                tarefas?.map(
                  ministerio =>
                    <MenuItem value={ministerio?.id}>
                      {ministerio?.descricao}
                    </MenuItem>
                )
              }
            </Select>
          )
        }
      </Grid>
    </>
  )
}
